// 02.3-client.md paso b -- extraído de `renderUnidadesDeNegocioTabs` en SubPanelTratos.jsx.
// Presentacional: sin `clientApi`/hooks/toast -- toda la data y los `on*` vienen por props.
// `renderUpload` es una render-prop (misma composición DocUploadCard+ObservacionField que usa
// el resto de SubPanelTratos.jsx para sus propios uploads) -- evita duplicar esa composición
// acá y mantiene un solo lugar dueño de `documents`/`uploadingType`/toggles de observaciones.
// Estilos inline preservados verbatim (conversión a tokens es el paso `e`).
export default function UnidadesDeNegocioPanel({ unidades, activeUnidadId, onSelectUnidad, onAddUnidad, onUnidadFieldChange, renderUpload }) {
    const activeUnidad = unidades.find((u) => u.id === activeUnidadId) || unidades[0];
    if (!activeUnidad) return null;

    const mixTotal = parseInt(activeUnidad.mix_debito ?? 30, 10) + parseInt(activeUnidad.mix_credito ?? 50, 10) + parseInt(activeUnidad.mix_intl ?? 20, 10);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0px', marginTop: 'var(--space-3)' }}>
            {/* Tabs Row */}
            <div className="hide-scrollbar" style={{
                display: 'flex',
                gap: 'var(--space-2)',
                overflowX: 'auto',
                borderBottom: '1px solid rgba(255,255,255,0.1)',
                position: 'sticky',
                top: '-24px',
                zIndex: 10,
                backgroundColor: '#0d0d0d',
                paddingTop: 'var(--space-3)',
                paddingBottom: '0px',
            }}>
                {unidades.map((u) => (
                    <button
                        key={u.id}
                        onClick={() => onSelectUnidad(u.id)}
                        style={{
                            padding: 'var(--space-2) var(--space-4)',
                            background: activeUnidadId === u.id ? 'rgba(255,255,255,0.05)' : 'transparent',
                            color: activeUnidadId === u.id ? '#3b82f6' : 'rgba(255,255,255,0.5)',
                            border: 'none',
                            borderBottom: activeUnidadId === u.id ? '2px solid #3b82f6' : '2px solid transparent',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            fontWeight: '600',
                            transition: 'all 0.2s',
                            marginBottom: '-1px',
                        }}
                    >
                        {u.nombre || 'Sin nombre'}
                    </button>
                ))}
                <button
                    onClick={onAddUnidad}
                    style={{
                        padding: 'var(--space-2) var(--space-3)',
                        background: 'transparent',
                        color: '#10b981',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--space-1)',
                        marginBottom: '-1px',
                    }}
                >
                    + Añadir
                </button>
            </div>

            {/* Active Unit Form */}
            <div style={{
                background: 'rgba(255,255,255,0.02)',
                padding: 'var(--space-6) var(--space-5)',
                borderRadius: '0 0 var(--radius-lg) var(--radius-lg)',
                border: '1px solid rgba(255,255,255,0.05)',
                borderTop: 'none',
                marginBottom: 'var(--space-4)',
            }}>
                <div className="op-sub-panel-field"><label htmlFor="unidad-nombre">Nombre de unidad de negocio</label>
                    <input id="unidad-nombre" type="text" autoComplete="organization" value={activeUnidad.nombre || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'nombre', e.target.value)} className="op-auto-input" placeholder="Nombre" />
                </div>
                <div className="op-sub-panel-field"><label htmlFor="unidad-direccion">Dirección de unidad de negocio</label>
                    <input id="unidad-direccion" type="text" autoComplete="street-address" value={activeUnidad.direccion || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'direccion', e.target.value)} className="op-auto-input" placeholder="Dirección completa" />
                </div>

                <div className="op-sub-panel-divider" style={{ marginTop: 'var(--space-4)' }}>FOTOS Y COMPROBANTES DE LA UNIDAD</div>
                <div className="op-sub-panel-uploads">
                    {renderUpload('Comprobante de domicilio', `comprobante_${activeUnidad.id}`)}
                    {renderUpload('Foto del local', `foto_local_${activeUnidad.id}`)}
                    {renderUpload('Foto puerta principal', `foto_puerta_${activeUnidad.id}`)}
                    {renderUpload('Foto de calle', `foto_calle_${activeUnidad.id}`)}
                    {renderUpload('Foto interior', `foto_interior_${activeUnidad.id}`)}
                    {renderUpload('Más fotos (Opcional)', `mas_fotos_${activeUnidad.id}`)}
                </div>

                <div className="op-sub-panel-divider" style={{ marginTop: 'var(--space-4)' }}>DATOS OPERATIVOS</div>
                <div className="op-sub-panel-grid">
                    <div className="op-sub-panel-field"><label htmlFor="unidad-terminales">No. de terminales</label>
                        <input id="unidad-terminales" type="number" value={activeUnidad.terminales_num || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'terminales_num', e.target.value)} className="op-auto-input" />
                    </div>
                    <div className="op-sub-panel-field"><label htmlFor="unidad-tx-mes">Transacciones / mes</label>
                        <input id="unidad-tx-mes" type="number" value={activeUnidad.tx_mes || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'tx_mes', e.target.value)} className="op-auto-input" />
                    </div>
                    <div className="op-sub-panel-field"><label htmlFor="unidad-ventas">Ventas anuales</label>
                        <input id="unidad-ventas" type="text" value={activeUnidad.ventas_anuales || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'ventas_anuales', e.target.value)} className="op-auto-input" />
                    </div>
                    <div className="op-sub-panel-field"><label htmlFor="unidad-ticket">Ticket promedio</label>
                        <input id="unidad-ticket" type="text" value={activeUnidad.ticket_promedio || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'ticket_promedio', e.target.value)} className="op-auto-input" />
                    </div>
                    <div className="op-sub-panel-field"><label htmlFor="unidad-hora-apertura">Hora apertura</label>
                        <input id="unidad-hora-apertura" type="time" value={activeUnidad.hora_apertura || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'hora_apertura', e.target.value)} className="op-auto-input" />
                    </div>
                    <div className="op-sub-panel-field"><label htmlFor="unidad-hora-salida">Hora salida</label>
                        <input id="unidad-hora-salida" type="time" value={activeUnidad.hora_salida || ''} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'hora_salida', e.target.value)} className="op-auto-input" />
                    </div>
                </div>

                <div className="op-sub-panel-field">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <label style={{ marginBottom: 0 }}>Mix de tipo de tarjeta (%)</label>
                        <div style={{ fontSize: '11px', color: mixTotal === 100 ? '#10b981' : '#ff4444' }}>
                            Total: {mixTotal}%
                        </div>
                    </div>
                    <div className="op-sub-panel-sliders" style={{ marginTop: 'var(--space-3)' }}>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '80px' }}>Débito</span>
                            <input type="range" aria-label="Mix de tarjeta débito (%)" value={activeUnidad.mix_debito ?? 30} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'mix_debito', e.target.value)} style={{ flex: 1, margin: '0 var(--space-3)' }} />
                            <span style={{ width: '30px', textAlign: 'right' }}>{activeUnidad.mix_debito ?? 30}%</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', marginTop: 'var(--space-2)' }}>
                            <span style={{ width: '80px' }}>Crédito</span>
                            <input type="range" aria-label="Mix de tarjeta crédito (%)" value={activeUnidad.mix_credito ?? 50} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'mix_credito', e.target.value)} style={{ flex: 1, margin: '0 var(--space-3)' }} />
                            <span style={{ width: '30px', textAlign: 'right' }}>{activeUnidad.mix_credito ?? 50}%</span>
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', marginTop: 'var(--space-2)' }}>
                            <span style={{ width: '80px' }}>Intl.</span>
                            <input type="range" aria-label="Mix de tarjeta internacional (%)" value={activeUnidad.mix_intl ?? 20} onChange={(e) => onUnidadFieldChange(activeUnidad.id, 'mix_intl', e.target.value)} style={{ flex: 1, margin: '0 var(--space-3)' }} />
                            <span style={{ width: '30px', textAlign: 'right' }}>{activeUnidad.mix_intl ?? 20}%</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}
